import { styled } from '@mui/system'
import { Colors } from 'constants/colors'
import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'

const FooterContainer = styled('div')({
  width: '100%',
  height: '120px',
  background: Colors.backgroundDark,
  borderRadius: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '40px',
})

const FooterContent = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '0 20px',
})
const FooterCopy = styled('p')({
  fontSize: '14px',
  fontWeight: 400,
  color: Colors.darkCoolGray,
  opacity: '0.7',
})
// const SocialLink = styled('a')()
const SocialLink = styled('a')({})
const FooterSocial = styled('div')({})
const FooterFacebook = styled(FacebookIcon)({
  fontSize: '18px',
  color: Colors.darkCoolGray,
  margin: '0px 15px',
})
const FooterTwitter = styled(TwitterIcon)({
  fontSize: '18px',
  color: Colors.darkCoolGray,
  margin: '0px 15px',
})
const FooterStyle = {
  FooterContainer,
  FooterContent,
  FooterCopy,
  FooterSocial,
  FooterFacebook,
  FooterTwitter,
  SocialLink,
}

export default FooterStyle
